import { Link } from 'react-router-dom'
import './InvolvedAudience.css'
import './ForYouth.css'

function ForYouth() {
  return (
    <div className="audience-page">
      <div className="audience-panel youth-panel">
        <h1 className="audience-title">For Youth</h1>
        <p className="audience-intro">
          Kia ora. If you are college age and curious about spiritual stuff,
          you are in the right place. Taha Wairua is a space where you can show
          up as yourself, feel safe, and explore without pressure.
        </p>

        <section className="audience-section">
          <h2>What to expect</h2>
          <ul className="audience-list">
            <li>
              Whanaungatanga Time (3:15pm-4:15pm): open hangout, free arvo tea,
              games, and good people.
            </li>
            <li>
              Wairua Time (4:30pm-5:15pm, opt-in): karakia and guided exercises
              like journaling, breath prayers, gratitude, meditation, and more.
            </li>
            <li>
              Closing Time (5:15pm-5:30pm): karakia and then pickup/drop-off.
            </li>
          </ul>
        </section>

        <section className="audience-section">
          <h2>No pressure</h2>
          <p>
            You will not be judged, assessed, or forced to believe anything.
            Wairua Time is optional, and you choose how deep you want to go.
          </p>
          <p className="audience-quote">
            Come for the whanaungatanga first, then decide if you want to try
            the wairua part.
          </p>
        </section>

        <section className="audience-section">
          <h2>Got questions?</h2>
          <p>
            Reach out through the <Link to="/contact" className="audience-link">Contact</Link>{' '}
            page and we can help.
          </p>
        </section>
      </div>
    </div>
  )
}

export default ForYouth
